import Modal from './Modal';
import { InformationCircleIcon } from '@heroicons/react/outline';
import { useState } from 'react';
interface InfoButtonProps {
  title: string;
  description: string;
}

const InfoButton = ({ title, description }: InfoButtonProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <>
      <InformationCircleIcon
        onClick={() => setIsModalOpen(true)}
        className=" text-warmGray-600 w-7 h-7 cursor-pointer"
      />

      <Modal
        title={title}
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      >
        <div>
          <span className="font-bold text-lg mr-1 text-textPrimary">
            {title}
          </span>
          <span className="text-base text-textSecondary">{description}</span>
        </div>
      </Modal>
    </>
  );
};

export default InfoButton;
